import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Barbers } from "./components/Barbers";
import { Services } from "./components/Services";
import { Gallery } from "./components/Gallery";
import { Reviews } from "./components/Reviews";
import { LocationHours } from "./components/LocationHours";
import { Footer } from "./components/Footer";
import { setLenis } from "./lib/scroll";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App bg-[#0c1220]">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-lg focus:bg-[#4a9bdc] focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-white"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content">
        <Hero />
        <Marquee />
        <Barbers />
        <Services />
        <Gallery />
        <Reviews />
        <LocationHours />
      </main>
      <Footer />
    </div>
  );
}

export default App;
